import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import API, { showNetworkErrorToast } from "Utils/api";

/**
 * `rejectWithValue` payload when `GET /api/v1/roles/` answers 403. The endpoint
 * is admin-only on cloud-core (DEV-4481), so for any other principal this is
 * the expected "not permitted" answer, not a failure worth a toast (DEV-6316).
 */
export const ROLES_FORBIDDEN = "forbidden";

export const fetchGetRoles = createAsyncThunk<
  UserRole[],
  void,
  { rejectValue: typeof ROLES_FORBIDDEN | undefined }
>("currentUser/fetchGetRoles", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get("roles/");
    return response.data.results;
  } catch (error) {
    if ((error as AxiosError)?.response?.status === 403) {
      return rejectWithValue(ROLES_FORBIDDEN);
    }
    showNetworkErrorToast(error);
    return rejectWithValue(undefined);
  }
});
